import(/* webpackMode: "eager" */ "/app/node_modules/antd/dist/reset.css");
import(/* webpackMode: "eager" */ "/app/node_modules/react-loading-skeleton/dist/skeleton.css");
import(/* webpackMode: "eager" */ "/app/src/assets/styles/globals.scss");
import(/* webpackMode: "eager" */ "/app/src/components/UI/VerficationCode/verificationCode.scss");
import(/* webpackMode: "eager" */ "/app/src/core/providers/IndexProvider.tsx");
import(/* webpackMode: "eager" */ "/app/src/core/providers/redux/ReduxProvider.tsx")